import { render, staticRenderFns } from "./EventoCalendario.vue?vue&type=template&id=65b41e6c&"
import script from "./EventoCalendario.vue?vue&type=script&lang=js&"
export * from "./EventoCalendario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports